'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DataSelector = require('../../common/Class/DataSelector');

var _DataSelector2 = _interopRequireDefault(_DataSelector);

var _Helpers = require('../../common/Helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectors = {
  overlay: new _DataSelector2.default('data-overlay')
};

var dom = {};
var ACTIVE_CLASS = 'is-active';
var SCROLL_LOCK_CLASS = 'no-scroll';
var EVENT_DISABLE = 'disable';

/** @private */
var cacheDom = function cacheDom() {
  dom.overlay = document.querySelector(selectors.overlay.bracketed());
};

/** @private */
var bindListeners = function bindListeners() {
  dom.overlay.addEventListener('click', Overlay.disable.bind(Overlay));
  window.addEventListener('keyup', (0, _Helpers.onKeys)([27], Overlay.disable.bind(Overlay)));
};

/**
 * @module Overlay
 * @emits 'disable'
 */
var Overlay = {
  /** @returns {Overlay} */
  init: function init() {
    cacheDom();
    bindListeners();

    return Overlay;
  },


  /** @returns {Overlay} */
  enable: function enable() {
    if (!this.enabled) {
      dom.overlay.classList.add(ACTIVE_CLASS);
      // document.body.classList.add(SCROLL_LOCK_CLASS);
      // document.documentElement.classList.add(SCROLL_LOCK_CLASS);
    }

    return Overlay;
  },


  /** @returns {Overlay} */
  disable: function disable() {
    if (this.enabled) {
      dom.overlay.classList.remove(ACTIVE_CLASS);
      // document.body.classList.remove(SCROLL_LOCK_CLASS);
      // document.documentElement.classList.remove(SCROLL_LOCK_CLASS);
      dom.overlay.dispatchEvent(new Event(EVENT_DISABLE, { bubbles: false }));
    }

    return Overlay;
  },


  /** @returns {Boolean} */
  get enabled() {
    if (dom.overlay) {
      return dom.overlay.classList.contains(ACTIVE_CLASS);
    }

    return false;
  },

  /** @alias Element.addEventListener */
  on: function on() {
    if (dom.overlay) {
      var _dom$overlay;

      (_dom$overlay = dom.overlay).addEventListener.apply(_dom$overlay, arguments);
    }
  },


  /** @alias Element.removeEventListener */
  off: function off() {
    if (dom.overlay) {
      var _dom$overlay2;

      (_dom$overlay2 = dom.overlay).removeEventListener.apply(_dom$overlay2, arguments);
    }
  }
};

exports.default = Overlay;